import React, { Component } from 'react';
import { array } from 'prop-types';
import Modal from 'sub_components/Common/PortalModalNew';
import BadgeModal from 'sub_components/Profile/BadgeModal';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const AtlantaDefault = `${CDN_URL}storage/atlanta-building-lg.svg`;
const BirminghamDefault = `${CDN_URL}storage/birmingham-building-lg.svg`;
const ChattanoogaDefault = `${CDN_URL}storage/chattanooga-building-lg.svg`;
const HuntsvilleDefault = `${CDN_URL}storage/huntsville-building-lg.svg`;
const badgeImage = `${CDN_URL}profile/icon-badge.svg`;
//const LOCATIONS = { 3: 'atlanta', 1: 'birmingham', 2: 'chattanooga', 4: 'huntsville' };
const LOCATIONS = { 1: 'birmingham', 2: 'chattanooga', 4: 'huntsville' };

class LocationDisplay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showModal: false,
			selectedLocation: null,
		};
	}
	getLocationImage = id => {
		if (!id) {
			return null;
		}
		if (LOCATIONS[id] === 'atlanta') {
			return AtlantaDefault;
		} else if (LOCATIONS[id] === 'birmingham') {
			return BirminghamDefault;
		} else if (LOCATIONS[id] === 'chattanooga') {
			return ChattanoogaDefault;
		} else {
			return HuntsvilleDefault;
		}
	};

	getMultipleLocations = () => {
		const { locations, module } = this.props;

		const className = locations.length <= 3 ? 'hide' : '';
		const storageSection = module === 'storage' ? true : false;

		return (
			<div className={`multi-location-container ${className}`}>
				{locations &&
					locations.length &&
					locations.map(location => (
						<div className='multi-location-card'>
							<div className='location-icon'>
								<img src={this.getLocationImage(location.id)} />
							</div>
							<div className='type-container'>
								<div className='location-title heading91'>{LOCATIONS[location.id]}</div>
								{location?.copy_count !== 0 && location?.copy_count && (
									<div className='copy-count heading91'>
										{location?.copy_count !== 1 ? `${location?.copy_count} copies` : '1 copy'}
									</div>
								)}
							</div>
						</div>
					))}
				<div className='middle-divider'></div>
				<div className='top-middle-divider'></div>
				<div className='bottom-middle-divider'></div>
				{!storageSection && (
					<div
						className='badge-access'
						onClick={() => {
							this.openModal();
						}}
					>
						<img src={badgeImage} />
					</div>
				)}
			</div>
		);
	};

	onClose = () => {
		this.setState({ showModal: false });
	};
	openModal = location => {
		this.setState({ showModal: true, selectedLocation: location });
	};

	getSecondLocation = locations => {
		return (
			<div className='location-card'>
				<div className='location-icon'>
					<img src={this.getLocationImage(locations[1].id)} />
				</div>
				<div className='type-container'>
					<div className='location-title heading70'>{LOCATIONS[locations[1].id]}</div>
					{locations[1]?.copy_count && locations[1]?.copy_count !== 0 && (
						<div className='copy-count heading52'>
							{locations[1]?.copy_count !== 1 ? `${locations[1]?.copy_count} copies` : '1 copy'}
						</div>
					)}
				</div>
			</div>
		);
	};

	render() {
		const { locations, module, setModalContent, rosterUser } = this.props;
		const { showModal, selectedLocation } = this.state;
		const hasSecondLocation = !!(locations && locations.length === 2);
		const hasMultipleLocations = !!(locations && locations.length >= 3);
		const storageSection = module === 'storage' ? true : false;

		if (!locations) {
			return <div></div>;
		} else {
			return (
				<div
					className={
						hasSecondLocation ? 'location-card-container two-locations' : 'location-card-container'
					}
				>
					{locations && locations.length >= 1 && !hasMultipleLocations && (
						<div className='location-card'>
							<div className='location-icon'>
								<img src={this.getLocationImage(locations[0].id)} />
							</div>
							<div className='type-container'>
								<div className='location-title heading70'>{LOCATIONS[locations[0].id]}</div>
								{locations[0]?.copy_count && locations[0]?.copy_count !== 0 && (
									<div className='copy-count heading52'>
										{locations[0]?.copy_count !== 1
											? `${locations[0]?.copy_count} copies`
											: '1 copy'}
									</div>
								)}
							</div>
						</div>
					)}
					{hasSecondLocation && this.getSecondLocation(locations)}
					{!storageSection && (
						<div
							className='badge-access'
							onClick={() => {
								this.openModal();
							}}
						>
							<img src={badgeImage} />
							<div className='badge-tooltip footer20'>Manage Badges</div>
						</div>
					)}
					{hasMultipleLocations && this.getMultipleLocations()}
					{showModal && (
						<Modal>
							<BadgeModal
								closeModal={this.onClose}
								selectedLocation={selectedLocation}
								setModalContent={setModalContent}
								rosterUser={rosterUser}
							/>
						</Modal>
					)}
				</div>
			);
		}
	}
}
LocationDisplay.propTypes = {
	locations: array,
};

LocationDisplay.defaultProps = {
	locations: [],
};

export default LocationDisplay;
